import React, { useCallback, useContext, useMemo } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import Banner from '@atlaskit/banner';
import Button from '@atlaskit/button';
import WarningIcon from '@atlaskit/icon/glyph/warning';

import DeploymentsLogo from '../../../assets/deployments-logo.png';
import { TWO_STEP_VERIFICATION_LINK } from '../const';
import { OnboardingType } from '../types';

import Header from './Header';
import OnboardingContext from './OnboardingContext';
import {
  Center,
  DeploymentsWrapper,
  StyledDeployments,
  ValuePropContainer,
} from './styled';

type Props = {
  onboardingType: OnboardingType;
};

const TwoStepVerification = ({ onboardingType }: Props) => {
  const { analyticsSource } = useContext(OnboardingContext);
  const { createAnalyticsEvent } = useAnalyticsEvents();

  const onViewTwoStepVerfificationPage = useCallback(() => {
    createAnalyticsEvent({
      action: 'clicked',
      actionSubject: 'button',
      actionSubjectId: 'twoFactorRequiredLink',
      source: analyticsSource,
    }).fire();
  }, [analyticsSource, createAnalyticsEvent]);

  const renderBanner = useMemo(() => {
    return (
      <Banner
        appearance="warning"
        icon={<WarningIcon label="" secondaryColor="inherit" />}
      >
        <Button
          onClick={onViewTwoStepVerfificationPage}
          href={TWO_STEP_VERIFICATION_LINK}
          target="_blank"
          appearance="link"
          spacing="none"
        >
          Two-step verification
        </Button>{' '}
        is required to enable Deployments
      </Banner>
    );
  }, [onViewTwoStepVerfificationPage]);

  return onboardingType === OnboardingType.PIPELINES ? (
    <ValuePropContainer>
      <Header />
      <br />
      {renderBanner}
    </ValuePropContainer>
  ) : (
    <DeploymentsWrapper>
      <Center>
        <StyledDeployments src={DeploymentsLogo} alt="Deployment" />
        <h3>Deployment tracking with Bitbucket</h3>
      </Center>
      {renderBanner}
    </DeploymentsWrapper>
  );
};

export default React.memo(TwoStepVerification);
